import axios from 'axios'

export default {

    state: {
        admissionTermMechanicTime: null,
        dealers: [],
        brands: [
            {
                val: 'BMW',
                name: 'BMW',
                image: require('../assets/BMW_White-Colour_RGB.png')
            },
            {
                val: 'BMWi',
                name: 'BMWi',
                image: require('../assets/BMW_i_White-Colour_RGB.png')
            },
            {
                val: 'MINI',
                name: 'MINI',
                image: require('../assets/MINI_LOGO_CZARNE.png')
            }
        ],
        services: [],
        timeOfday: [
            {
                val: 1,
                name: 'O każdej porze',
                term: {
                    hour_from: null,
                    hour_to: null
                }
            },
            {
                val: 2,
                name: 'Przed południem',
                term: {
                    hour_from: null,
                    hour_to: 12
                }
            },
            {
                val: 3,
                name: 'Po południu',
                term: {
                    hour_from: 12,
                    hour_to: null
                }
            }
        ],
        localizationsOpenHours: [
            { // Poznań
                id: 1,
                hour_to: "18:31"
            },
            { // Warszawa
                id: 2,
                hour_to: "16:31"
            },
            { // Wrocek
                id: 3,
                hour_to: "18:31"
            },
            { // Warszawa Park
                id: 11,
                hour_to: "18:31"
            },
            { // Ten testowy jakiś
                id: 16,
                hour_to: "18:31"
            }
        ],
        // additionalOptions: [
        //     {
        //         id: 1,
        //         val: 'Chcę czekać na ukończenie naprawy pojazdu',
        //         name: 'Chcę czekać na ukończenie naprawy pojazdu',
        //         disable: [2, 3, 4],
        //         disableVar: () => {
        //             let selectedGroups = this.$store.getters['definitions/getLeadSelectedGroupIds'];
        //             // jak jest grupa serwis + disgnostyka komp. lub disgnostyka mech.
        //             return selectedGroups.includes(8) && (selectedGroups.includes(6) || selectedGroups.includes(7))
        //         },
        //         default: {
        //             mechanic_offset_max: 60,
        //             mechanic_time: 60
        //         }
        //     },
        //     {
        //         id: 2,
        //         val: 'Potrzebuje mobilności',
        //         disableVar: () => {
        //             let selectedGroups = this.$store.getters['definitions/getLeadSelectedGroupIds'];
        //             // jak jest grupa serwis + disgnostyka komp. lub disgnostyka mech.
        //             return selectedGroups.includes(8) && (selectedGroups.includes(6) || selectedGroups.includes(7))
        //         },
        //         name: 'Potrzebuje mobilności',
        //         disable: [1],

        //     },
        //     {
        //         id: 3,
        //         val: 'Zostawiam auto do końca dnia - Najszybsza opcja rezerwacji',
        //         name: 'Zostawiam auto do końca dnia - Najszybsza opcja rezerwacji',
        //         disable: [1, 4],
        //         disableVar: () => {
        //             let selectedGroups = this.$store.getters['definitions/getLeadSelectedGroupIds'];
        //             // jak jest grupa serwis + disgnostyka komp. lub disgnostyka mech.
        //             return selectedGroups.includes(8) && (selectedGroups.includes(6) || selectedGroups.includes(7))
        //         },
        //         default: {
        //             mechanic_offset_max: null,
        //             mechanic_same_day: 1,
        //             mechanic_time: 60
        //         }
        //     },
        //     {
        //         id: 4,
        //         val: 'Serwis 24 - oddaj auto o wybranej godzinie, Odbierz następnego dnia o 10:00',
        //         name: 'Serwis 24 - oddaj auto o wybranej godzinie, Odbierz następnego dnia o 10:00',
        //         disable: [1, 3],
        //         default: {
        //             mechanic_next_day_hour: 8,
        //             mechanic_same_day: null,
        //             mechanic_offset_max: null,
        //             mechanic_time: 30
        //         }
        //     }
        // ],
        operations: [],
        advisonGroups: [],
        mechanicGroups: [],
        admissionTerms: [],
        repairTerms: [],
        AvailableTerms: [],
        termComparedTimeBufor: 29, // margines czasu dla doradcy (połowa godziny 30min)
        serviceTermMoving: {
        //     10: () => { //wymiana opon i kół
        //         let today = new Date();
        //         let date = new Date();
        //         switch (date.getDay()) {
        //             case 5: // piątek + 3 dni
        //                 date.setDate(date.getDate() + 3);
        //                 break;
        //             case 6: // sobota + 3 dni
        //                 date.setDate(date.getDate() + 3);
        //                 break;
        //             case 0: // niedziela + 3 dni
        //                 date.setDate(date.getDate() + 2);
        //                 break;
        //             default:
        //                 // date.setDate(date.getDate()-1);
        //                 date.setTime(date.getTime() + (40 * 60 * 60 * 1000));
        //                 break;
        //         }

        //         return date;

        //     },
        //     13: () => { //szybka wymiana opon i kół
        //         let today = new Date();
        //         let date = new Date();
        //         switch (date.getDay()) {
        //             case 5: // piątek + 3 dni
        //                 date.setDate(date.getDate() + 3);
        //                 break;
        //             case 6: // sobota + 2 dni
        //                 date.setDate(date.getDate() + 2);
        //                 break;
        //             default:
        //                 // date.setDate(date.getDate()-1);
        //                 date.setTime(date.getTime() + (40 * 60 * 60 * 1000));
        //                 break;
        //         }


        //         return date;

        //     },
            default: () => {

                let date = new Date();
                switch (date.getDay()) {
                    case 5: // piąteczek, piątunio + 3 dni
                        date.setDate(date.getDate() + 3);
                        break;
                    case 6: // sobota + 2 dni
                        date.setDate(date.getDate() + 2);
                        break;
                    default:
                        // date.setDate(date.getDate()-1);
                        // WWA-16645 - remove bufor time
                        //date.setTime(date.getTime() + (48 * 60 * 60 * 1000));
                        break;
                }
                return date;

            }

        },
        detepickerConfig: {
            formatLocale: {
                // MMMM
                months: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
                // MMM
                monthsShort: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
                // dddd
                weekdays: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
                // ddd
                weekdaysShort: ['Niedz', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob'],
                // dd
                weekdaysMin: ['Nd', 'Po', 'Wt', 'Śr', 'Cz', 'Pt', 'So'],
                // first day of week
                firstDayOfWeek: 1
            },
            range(date) {
                return this.$store.getters['definitions/getFirstPossibleDate'] > date || typeof this.$store.getters['definitions/getDetepickerDates'](date) == 'string'
            },
            disabledDays: [
                '01-01', // Nowy Rok
                '01-06', // Święto Trzech Króli
                '04-04', // Wielkanoc
                '04-05', // Poniedziałek Wielkanocny
                '05-01', // Święto Pracy
                '05-03', // Święto Konstytucji 3 Maja
                '05-23', // Zielone Świątki
                '06-03', // Boże Ciało
                '08-15', // Święto Wniebowzięcie Najświętszej Maryi Panny
                '11-01', // Wszystkich Świętych
                '11-11', // Święto Niepodległości
                '12-25', // Boże Narodzenie
                '12-26' // Boże Narodzenie
            ],
            disabledDaysByDealer: [
               { // poznan
                        dealer_id: 1,
                        options: [
                            '29.03.2025',
                            '05.04.2025',
                            '19.04.2025',
                            '26.04.2025',
                            '12.04.2025'
                        ]
                    },
                    { // warszawa park
                        dealer_id: 11,
                        options: [
                            '22.03.2025',
                            '29.03.2025'
                        ]
                    },
                    { // warszawa
                        dealer_id: 2,
                        options: [
                            '22.03.2025',
                            '29.03.2025',
                            '12.04.2025'
                        ]
                    },
                    { //wroclaw
                        dealer_id: 3,
                        options: [
                           '22.03.2025',
                            '29.03.2025',
                            '12.04.2025'
                        ]
                    }
            ]
    },
        brand_id: 13,
        models: []
    },
    mutations: {
        setDealers(state, payload) {
            state.dealers = payload;
        },
        setAddmissionTerms(state, payload) {
            state.admissionTerms = payload;
        },
        setAddmissionTermMechanicTime(state, payload) {
            state.admissionTermMechanicTime = payload;
        },
        setRepairTerms(state, payload) {
            state.repairTerms = payload;
        },
        setReplacementCars(state, payload) {
            state.replacementCars = payload;
        },
        setAvailableTerms(state, payload) {
            state.AvailableTerms = [...payload].filter(e => e.mechanic_term);
        },
        setBrands(state, payload) {
            state.brands = payload
        },
        setModels(state, payload) {
            state.models = payload
        },
        setOperations(state, payload) {
            state.operations = payload;
        },
        setGroups(state, payload) {
            state.groups = payload;
        },
        setAdvisonGroups(state, payload) {
            state.advisonGroups = [...payload]
                .sort((a, b) => {
                    if (a.name === "Serwis") return -1;
                    if (b.name === "Serwis") return 1;
                    return 0;
                })
                .map(e => ({ ...e, toggle: false }));
        },
        setMechanicGroups(state, payload) {
            state.mechanicGroups = payload;
        }
    },
    getters: {
        getOperations: state => state.operations,
        getAdvisonGroups: state => state.advisonGroups,
        getMechanicGroups: state => state.mechanicGroups,
        getDealers: state => state.dealers,
        getBrands: state => state.brands,
        getServicesGroups: state => state.servicesGroups,
        getServices: state => state.services,
        getTimeOfDay: state => state.timeOfday,
        getTimeOfDayWithDealersHours: (state, getters, rootState, rootGetters) => {

            if (!rootGetters['lead/getLead'].dealer_id) {
                return state.timeOfday
            }

            let hourTo = state.localizationsOpenHours.find(e => e.id == rootGetters['lead/getLead'].dealer_id);

            return state.timeOfday.map(e => {
                return {
                    ...e,
                    term: {
                        ...e.term,
                        hour_to: e.term.hour_to == null && hourTo ? hourTo.hour_to : e.term.hour_to
                    }
                }
            })

        },
        getLeadSelectedGroupIds: (state, getters, rootState, rootGetters) => {
            const lead = rootGetters['lead/getLead'];
            
            const allServices = state.operations; 
            
            if (!lead || !lead.services_val || !allServices) {
                return [];
            }

            const selectedServices = allServices.filter(service => 
                lead.services_val.includes(service.id)
            );

            return [...new Set(selectedServices.map(s => s.group_id))];
        },
        // getAdditionalOptions: state => state.additionalOptions,
        getReplacementCars: state => state.replacementCars,
        getAddmissionTerms: state => state.admissionTerms,
        getAddmissionTermMechanicTime: state => state.admissionTermMechanicTime,
        getRepairTerms: state => state.repairTerms,
        getAvailableTerms: (state, getters, rootState, rootGetters) => state.AvailableTerms
        .filter(e => {
            let today = new Date();
            return e.timestamp.getTime() > today.getTime() && (rootGetters['lead/getLead'].services_val.includes(12) ? e.timestamp.getDay() !== 6 : true)
        }),
        getDetepickerConfig: state => state.detepickerConfig,
        getServiceTermMoving: state => state.serviceTermMoving,
        getLocalizationsOpenHours: state => state.localizationsOpenHours,
        getFirstPossibleDate: (state, getters, rootState, rootGetters) => {
            // // sprawdzam i pobieram index reguły dla ostatniej wybranej usługi
            // let serviceMovingIndex = Object.keys(state.serviceTermMoving).indexOf(String(rootGetters['lead/getLead'].services_val.slice(-1).pop()))
            // // jak znalazło regułę to ją odpalam
            // if (serviceMovingIndex >= 0) {
            //     var startDate = state.serviceTermMoving[Object.keys(state.serviceTermMoving)[serviceMovingIndex]]();
            // } else { // jak nie to default
            //     var startDate = state.serviceTermMoving.default();
            // }
            var startDate = state.serviceTermMoving.default();

            return startDate;
        },
        getAdditionalOptions: (state, getters, rootState, rootGetters) => {
            const selectedGroups = rootGetters['definitions/getLeadSelectedGroupIds'] || [];

            // jak serwis i diag komputerowa lub diag mechaniczna
            const isDisabled1 = selectedGroups.includes(8) && (selectedGroups.includes(6) || selectedGroups.includes(7));

            // jak diag komputerowa lub miechaniczna
            const isDisabled2 = selectedGroups.includes(6) || selectedGroups.includes(7);

            return [
                {
                    id: 1,
                    val: 'Chcę czekać na ukończenie naprawy pojazdu',
                    name: 'Chcę czekać na ukończenie naprawy pojazdu',
                    disable: [3, 4],
                    disableVar: () => isDisabled1,
                    default: {
                        mechanic_offset_max: 60,
                        mechanic_time: 60
                    }
                },
                {
                    id: 3,
                    val: 'Zostawiam auto do końca dnia - Najszybsza opcja rezerwacji',
                    name: 'Zostawiam auto do końca dnia - Najszybsza opcja rezerwacji',
                    disable: [1, 4],
                    disableVar: () => isDisabled1 || isDisabled2,
                    default: {
                        mechanic_offset_max: null,
                        mechanic_same_day: 1,
                        //mechanic_time: 60
                    }
                },
                {
                    id: 4,
                    val: 'Serwis 24 - obsługa w ciągu 24 godzin od przyjęcia samochodu',
                    name: 'Serwis 24 - obsługa w ciągu 24 godzin od przyjęcia samochodu',
                    disable: [1, 3],
                    default: {
                        mechanic_next_day_hour: 8,
                        mechanic_same_day: null,
                        mechanic_offset_max: 1320,
                        mechanic_time: 30
                    }
                },
                {
                    id: 2,
                    val: 'Potrzebuje mobilności',
                    name: 'Potrzebuje mobilności (Usługi dodatkowo płatne)',
                    subOptions: [
                        'Samochód zastępczy',
                        'Door to door',
                        'Taxi'
                    ],
                    //disableVar: () => isDisabled1 || isDisabled2,
                    disable: [1],
                },
            ];
        },
        getDetepickerDates: (state, getters, rootState, rootGetters) => (date) => {
            // 👉 Upewniamy się, że date to obiekt typu Date
            if (typeof date === 'string') {
                const parsed = new Date(date);
                if (isNaN(parsed)) {
                    console.warn('⛔ Nieprawidłowa data wejściowa (string):', date);
                    return false;
                }
                date = parsed;
            }

            // 🕒 Normalizacja daty
            const targetDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

            // 🎄 Sprawdzanie świąt (format MM-DD)
            const isHoliday = state.detepickerConfig.disabledDays.find(e => {
                const [month, day] = e.split('-').map(Number);
                const match = targetDate.getMonth() === (month - 1) && targetDate.getDate() === day;
                if (match) console.log(`🎄 Święto znalezione: ${e} pasuje do ${targetDate.toDateString()}`);
                return match;
            });

            // 🚫 Sprawdzanie dat zablokowanych przez dealera
            const dealer_id = rootGetters['lead/getLead'].dealer_id;
            let isDealerDisabled = false;

            if (dealer_id && targetDate) {
                const dealer = state.detepickerConfig.disabledDaysByDealer.find(d => d.dealer_id === dealer_id);
                if (dealer) {
                    isDealerDisabled = dealer.options.find(d => {
                        let blockedDate;
                        if (d.includes('.')) {
                            const [day, month, year] = d.split('.');
                            blockedDate = new Date(year, month - 1, day);
                        } else {
                            blockedDate = new Date(d);
                        }

                        const normalizedBlocked = new Date(blockedDate.getFullYear(), blockedDate.getMonth(), blockedDate.getDate());
                        const match = normalizedBlocked.getTime() === targetDate.getTime();
                        if (match) console.log(`🚫 Data zablokowana przez dealera: ${d} pasuje do ${targetDate.toDateString()}`);
                        return match;
                    });
                }
            }

            const isPast = new Date().setHours(0, 0, 0, 0) > targetDate.getTime();

            // 🪵 Logi
            console.log('📆 Sprawdzana data:', targetDate.toDateString());
            console.log('🎄 isHoliday:', Boolean(isHoliday));
            console.log('🚫 isDealerDisabled:', Boolean(isDealerDisabled));
            console.log('⏳ isPast:', isPast);

            return isPast || isHoliday || isDealerDisabled;
        },
        getBrands: state => state.brands,
        getModels: state => state.models
    },
    actions: {
        async fetchDealers({ commit, state }) {
            const { data } = await axios.get('/dealers?service=1&brand_id=13');
            commit('setDealers', data.dealers);
        },
        // async fetchBrands({commit,state}) {
        //     const {data} = await axios.get('/car-brands-all');
        //     commit('setBrands',data.brands);
        // },
        async fetchModels({ commit, state, rootState }) {
            const { data } = await axios.get('/car-models-all', {
                params: {
                    brand_id: rootState.lead.lead.brand_val == 'BMW Motorrad' ? 411 : state.brand_id,
                    limit: 10000
                }
            });
            commit('setModels', data.models);
        },
        async fetchServiceAdmissionTerms({ commit, state }, params) {
            console.log('params');
            console.log(params);
            
            
            // if (params.mechanic_time && params.mechanic_time == 60) {
            //     params.mechanic_time = null;
            // }
            commit('setAvailableTerms', []);

            const { data } = await axios.get('/service-admission-terms', {
                params: {
                    mechanic: 1,
                    mechanic_offset_min: state.termComparedTimeBufor,
                    mechanic_offset_max: 180,
                    mechanic_same_day: 1,
                    mechanic_required: 1,
                    ...params,
                }
            });
            let terms = data.terms.map((e) => {
                let timestamp = new Date(e.date + 'T' + e.hour_zeros + ':00');
                return {
                    ...e,
                    timestamp
                }
            })
            commit('setAvailableTerms', terms);
            // wywalam bo rezerwowało za mało czasu mechanikowi
            //commit('setAddmissionTermMechanicTime', data.default_mechanic_time)
        },
        async fetchServiceCars({ commit, state, rootState }, params) {
            const { data } = await axios.get('/service-cars', {
                params: {
                    dealer_id: rootState.lead.lead.dealer_id,
                    date: rootState.lead.lead.date,
                    hour: rootState.lead.lead.hour_from,
                    hour_to: rootState.lead.lead.hour_to
                }
            });
            commit('setReplacementCars', data.cars);
        },
        async fetchOperations({ commit }, params) {
            const { data } = await axios.get('/service/operations', { params })
            
            commit('setOperations', data.operations.map(e => ({...e, time: e.time*5})));
            commit('setAdvisonGroups', data.groups);
        },
        async fetchAdvisonGroups({ commit }, params) {
            const { data } = await axios.get('/service/advisor-groups', { params })
            commit('setAdvisonGroups', data.groups);
        },
        async fetchMechanicGroups({ commit }, params) {
            const { data } = await axios.get('/service/mechanic-groups', { params })
            commit('setMechanicGroups', data.groups);
        },
    },
    namespaced: true
}